import axios from 'axios';

export const getUserProgressCertificate = async (email, startDate, endDate) => {
  console.log('===> getUserProgressCertificate (certs.api 4):', email, startDate, endDate)
  const axiosInstance = axios.create({
    withCredentials: true
  });
  const response = await axiosInstance.get(
    process.env.REACT_APP_API + `/certificate-data?email=${email}&startDate=${startDate}&endDate=${endDate}`
  );
  console.log('===> getUserProgressCertificate:', response)
  return response;
};